// extracted by css-extract-rspack-plugin
export default {"value":"ru7BgD6Lf74WLrTK","label":"pbk3dX77u0isk3fg"};